import { render, staticRenderFns } from "./dao1.vue?vue&type=template&id=1c5e462b&scoped=true&"
import script from "./dao1.vue?vue&type=script&lang=js&"
export * from "./dao1.vue?vue&type=script&lang=js&"
import style0 from "./dao1.vue?vue&type=style&index=0&id=1c5e462b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e462b",
  null
  
)

export default component.exports